import React, { useState } from "react";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { MdOutlineMessage } from "react-icons/md";
import { callApi } from "../../constant/callApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FeedBack = () => {
  const [show, setShow] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [errors, setErrors] = useState({});
  const [btnLoading,setBtnLoading]=useState(false)

  const style = {};

  style.errorSpan = {
    color: "red",
    fontSize: "12px",
  };
  style.errorBox = {
    border: "1px solid red",
  };

  const handelError = () => {
    let error = {};
    if (!feedback) {
      error.feedback = "This field is required";
    }
    setErrors(error);
    return error;
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSubmit = async () => {
    setBtnLoading(true)
    try {
      const error = handelError();
      if (Object.keys(error).length > 0) {
        return;
      }

      const config = {
        method: "Post",
        url: "Portal/feedBack/addFeedBack",
        data: {
          feedback: feedback,
        },
      };
      const response = await callApi(config);
      if (response?.data?.code == 200) {
        toast.success(response?.data?.message, { autoClose: 2000 });
        handleClose();
      } else {
        toast.success(response?.data?.message, { autoClose: 2000 });
      }
    } catch (error) {
      console.log(error);
    }
    finally{

        setBtnLoading(false)
        setErrors({})
        setFeedback('')
    }
  };

  return (
    <>
      <div>
        <a
          id="feedback-btn"
          onClick={handleShow}
          style={{ cursor: "pointer", fontSize: "24px" }}
        >
          <MdOutlineMessage />
        </a>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header style={{ background: "#921D1E", color: "white" }}>
          <div className="d-flex align-items-center justify-content-center w-100">
            {/* <img src={waringSign} alt="warn" /> */}
            <MdOutlineMessage size={60} />
          </div>
        </Modal.Header>
        <Modal.Body>
          <h2
            style={{
              color: "#921D1E",
              fontSize: "28px",
              fontFamily: "Roboto",
              textAlign: "center",
            }}
          >
            Feedback
          </h2>
          {/* <p style={{ fontSize: '16px', marginTop: '20px', fontFamily: 'Roboto', textAlign: 'center' }}>Add feedback here:</p> */}
          <Form>
            <Form.Group controlId="feedbackTextarea">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Type your feedback here..."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              />
              {errors.feedback && (
                <span className="errorPresent" style={style.errorSpan}>
                  {errors.feedback}
                </span>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="primary"
            onClick={handleClose}
            style={{
              fontSize: "16px",
              fontWeight: "600",
              fontFamily: "Roboto",
              textAlign: "center",
              border: "1px solid #DEBBBB",
              color: "#921D1E",
              background: "#F9F3F4",
            }}
          >
            Close
          </Button>
          {
            btnLoading ?
            <Spinner
            style={{
             color:"brown"
            }}
            size="sm"
           />:
           <Button
           variant="primary"
           onClick={handleSubmit}
           style={{
             fontSize: "16px",
             fontWeight: "600",
             fontFamily: "Roboto",
             textAlign: "center",
             border: "1px solid #DEBBBB",
             color: "#921D1E",
             background: "#F9F3F4",
           }}
           className="me-2"
         >
           Submit
         </Button>

          }
         
        
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FeedBack;
